import axios from 'axios'

let axiosInterceptor = null
let url = null
let errorUrl = null

const interceptor = (actions) => {
  if (!!axiosInterceptor) {
    axios.interceptors.request.eject(axiosInterceptor)
  }
  axiosInterceptor = axios.interceptors.response.use(
    (next) => {
      if (!url) {
        url = next.request.responseURL
        return Promise.resolve(next)
      }
      if (url !== next.request.responseURL) {
        url = next.request.responseURL
        return Promise.resolve(next)
      }
      return Promise.resolve(next)
    },
    (error) => {
      if (!errorUrl) {
        if (errorUrl.search('/system/user') > 0) {
          return Promise.reject(error)
        }

        errorUrl = error.config?.url
        actions.setOpen(true)
      }

      if (error.response.status === 400 && error.response.data?.toString().startsWith('NewUser')) {
        sessionStorage.removeItem('browserUser')
        window.location.reload(false)
        return Promise.resolve()
      }

      if (errorUrl !== error.config?.url) {
        errorUrl = error.response.config?.url
        return Promise.reject(error)
      }
      return Promise.reject(error)
    }
  )
}
const serviceBaseInterceptor = {
  interceptor,
}

export default serviceBaseInterceptor
